export default __webpack_public_path__ + "static/media/coming-soon-stick.35566907.png";